// eslint-disable
import { ShopLoginPlugin, AdminLoginPlugin } from '@holdingblachere/vue-common-ui';

const routes = [
  ...AdminLoginPlugin.routes,
  ...ShopLoginPlugin.routes,
  // Full Page Layout
  {
    path: '/u',
    component: () => import('@/layouts/FullPage/FullPage.vue'),
    children: [
      {
        path: '/login',
        name: 'OldLogin',
        redirect: 'Login',
      },
      {
        path: '/choix-utilisateur',
        name: 'Login',
        component: () => import('@/views/pages/Login.vue'),
        meta: {
          // guestOnly: true,
          shopAuth: true,
        },
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/views/pages/Logout.vue'),
        meta: { auth: true },
      },
    ],
  },
  {
    path: '/app',
    name: 'Dashboard',
    component: () => import('@/layouts/AppLayout/AppLayout.vue'),
    redirect: { name: 'SaisieInventory' },
    children: [
      {
        path: '/hello-world',
        name: 'HelloWorld',
        component: () => import('@/views/pages/HelloWorldPage.vue'),
        meta: { auth: true },
      },
      {
        path: '/saisie-conso',
        name: 'SaisieConso',
        component: () => import('@/views/pages/SaisieConsoPage.vue'),
        meta: { auth: true },
      },
      {
        path: '/history-conso',
        name: 'HistoryConso',
        component: () => import('@/views/pages/InventoryPage.vue'),
        meta: { auth: true },
      },
      {
        path: '/saisie-inventory',
        name: 'SaisieInventory',
        component: () => import('@/views/pages/SaisieInventoryPage.vue'),
        meta: { auth: true },
      },
      {
        path: '/history-inventory',
        name: 'HistoryInventory',
        component: () => import('@/views/pages/HistoriqueInventairePage.vue'),
        meta: { auth: true },
      },
    ],
  },
  {
    path: '/*',
    redirect: { name: 'Dashboard' },
  },
];

export default routes;
